const config = require('../config.json')

export const CREATE_EMAIL_ACCOUNT_URL = config.create_email_account_url
export const CREATE_EMAIL_ACCOUNT_URL_V2 = config.create_email_account_url_v2
export const GMAIL_PROVIDER = 'gmail'
